import BaseRepository from "./BaseRepository";

export default new (class WidgetsRepository extends BaseRepository {
  fetchAll(companyId) {
    return this.api.get(`/companies/${companyId}/widgets`);
  }
  createWidget(companyId, w) {
    if (w && w.widget && w.widget.options.href) {
      w.widget.options.href = w.widget.options.href.split("old.").join("");
    }
    return this.api.post(`/companies/${companyId}/widgets`, w);
  }
  updateWidget(companyId, w, wId) {
    const wProcessed = JSON.parse(JSON.stringify(w));
    delete wProcessed.widget.id;
    delete wProcessed.widget.companyId;
    if (wProcessed && wProcessed.widget && wProcessed.widget.options.href) {
      wProcessed.widget.options.href = wProcessed.widget.options.href.split("old.").join("");
    }
    return this.api.put(`/companies/${companyId}/widgets/${wId}`, wProcessed);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/WidgetsRepository.js